import React, { useState } from 'react';
import { ChevronRight } from 'react-feather';
import { useRemote } from '../../../Utils/Utils';
import Tooltip from '../../../components/popups/Tooltip';
import { toastSuccess } from '../../../components/popups/Toast';
import "./AssetClass.scss"


const AssetActionsPopup = ({ move, edit, remove, classes, asset, setImageUpload, setShowImageEditModal, setEditedAsset, allAssets, callbackFunction, newClass, moveCallback }) => {
    const remote = useRemote()
    const [moving, setMoving] = useState(false)
    const classesExcludingSelfAssetClass = classes.filter(c => c.id !== asset.assetClassId)

    function editLogo() {
        setEditedAsset(asset)
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.multiple = true;
        fileInput.onchange = (event) => { setImageUpload(event.target.files); setShowImageEditModal(asset.id) };
        fileInput.click();
    };

    function moveAsset(targetClass, asset) {
        // for simplicity, we just move one asset at a time, but the backend can handle multiple assets at once
        const newList = [{ ...asset, assetClassId: targetClass.id }]
        const payload = {
            id: targetClass.id,
            name: targetClass.name,
            assets: [...newList]
        }
        remote.put(`/assets/classes/${targetClass.id}/asset/move`, payload).then((resp) => {
            if (newClass) {
                moveCallback(asset.id)
                toastSuccess(`Asset has been moved to ${targetClass.name} `)
            } else {
                callbackFunction()
                toastSuccess(`Asset has been moved to ${targetClass.name} `)
            }
        })
    }

    function removeAsset(asset) {
        // const assetsOnClass = allAssets.filter(a => a.assetClassId === asset.assetClassId && a.id !== asset.id)
        // for simplicity, we just remove one asset at a time, but the backend can handle multiple assets at once
        const payload = {
            id: asset.assetClassId,
            name: classes.find(c => c.id === asset.assetClassId).name,
            assets: [{...asset}]
        }
        remote.delete(`/assets/classes/${asset.assetClassId}/asset`, payload ).then((resp) => {
            callbackFunction()
            toastSuccess(`Asset has been removed from ${classes.find(c => c.id === asset.assetClassId).name} `)
        })
    }


    return (<>
        <ul className='assets-actions-popup-wrapper'>
            {move &&
                <Tooltip padding='none' placement='left-start' outerStyle={{ width: '100%' }} label={
                    <ul className='assets-actions-popup-wrapper' onMouseEnter={() => setMoving(true)} onMouseLeave={() => setMoving(false)}>
                        {classesExcludingSelfAssetClass.map(targetClass => 
                        <li key={targetClass.id} className='assets-action-label' onClick={() => moveAsset(targetClass, asset)}>
                            {targetClass.name}
                        </li>)}
                    </ul>
                }>
                    <li className={`assets-action-label${moving ? ' moving-through' : ''}`}>
                        <div className='move-to'>
                            Move to
                            <ChevronRight size={20} />
                        </div>
                    </li>
                </Tooltip>
            }
            {edit && <li onClick={editLogo} className='assets-action-label'>
                Edit logo
            </li>}
            {remove && <li onClick={() => removeAsset(asset)} className='assets-action-label'>
                Remove from class
            </li>}
        </ul>
    </>);
}

export default AssetActionsPopup